module.exports = __webpack_public_path__ + "img/silver3.96b2c290.png";